import { SidebarMenuButton, SidebarMenuItem } from '@components/ui/sidebar';
import { isRouteItemActive, RouteItem } from '@utils/route-utils';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC } from 'react';

type NavItemProps = {
  item: RouteItem;
};

const NavItem: FC<NavItemProps> = ({ item }) => {
  const pathname = usePathname();

  return (
    <SidebarMenuItem key={item.id}>
      <SidebarMenuButton
        asChild
        isActive={isRouteItemActive(pathname, item)}
        tooltip={item.label}
        size={item.size || 'default'}
      >
        <Link href={item.href}>
          {item.icon && <item.icon />}
          <span>{item.label}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};

export default NavItem;
